/* eslint-disable */
import { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import Select from "react-select";
import cookie from "react-cookies";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, ecommerceapiUrl, clientheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  uploadFile,
  removeFile, isMultiSelect
} from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";
import PageLoader from "../../Helpers/PageLoader";
var module = "referralsettings";
var moduleName = "Referral Settings";
var modulePath = "/clientpanel/referralsettings";
const defaultTerms = '<ol><li>Voucher is valid for retail store redemption.</li><li>The voucher will be valid till consumed.</li> <li>Once sold, vouchers are non-refundable and cannot be exchanged.</li><li>Voucher is not transferrable, cash redeemable and not replaceable.</li><li>Voucher is to be redeemed at only the participating outlets and presented to outlet staff before ordering.</li><li>Voucher is not to be used in conjunction with other promotions, discounts, offers, vouchers and privileges.</li><li>All vouchers can be used multiple times in full or in partial.</li><li>Brand reserves the right to amend the terms & conditions as necessary, without prior notice.</li><li>Please show this E-Voucher on your handheld devices upon payment. You need not print this E-Voucher for redemption.</li></ol>'
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.EditID || '',
      pageloading: false,
      clientdata: {
        referralTitle: "",
        referralOutlet:[],
        referralInformation: '',
        referralTermsandConditions : defaultTerms,
        referrerPoints: "",
        refereePoints: "",
        referralImage: "",
        referralStatus: ""
      },
      btndisabled: false,
      loading: true,
      outletList: [],
      formpost: [],
      companyDetail: [],
    };
  }

  componentDidMount = async () => {
    this.loadOutlet();
    if (this.state.editID !== "") {
      var params = {
        url: `${apiUrl}${module}/details/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  };
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost != nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0]?.message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.navigate(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          var referralStatus = result.referralStatus === "A" ? "Active" : "Inactive";
          var status =
            result.referralStatus !== "" && result.referralStatus !== null
              ? {
                  label: referralStatus,
                  value: result.referralStatus,
                }
              : "";
       
          var clientupdatedata = {
            referralTitle: result.referralTitle,
            referralOutlet: result?.referralOutlet ?? [],
            referralInformation: result.referralInformation !== "" && result.referralInformation !== null ? result.referralInformation : "",
            referralTermsandConditions: (result.referralTermsandConditions!==null)?result.referralTermsandConditions:'',
            referrerPoints: result.referrerPoints,
            refereePoints: result.refereePoints,
            referralImage: result.referralImage,
            referralStatus: status
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid " + moduleName, "error");
        }
      });
    }
  }
  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { clientdata: { [field]: { $set: value } } }));
  };

  loadOutlet() {
     var urlShringTxt = ecommerceapiUrl + "outlet/dropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ outletList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
    }


  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;  
    const editorContent = $("#editorContent").val();
    const editorContent2 = $("#editorContent2").val();
    var referralOutlet = [];
    if (postData.referralOutlet.length > 0) {
      postData.referralOutlet.map((item) => {
        referralOutlet.push(item.value);
        return "";
      });
    }
    var postObject = {
      referralTitle: postData.referralTitle,
      referralOutlet: postData.referralOutlet.length > 0 ? referralOutlet.join(",") : "",
      referralInformation: editorContent,
      referralTermsandConditions:editorContent2,
      referrerPoints: postData.referrerPoints,
      refereePoints: postData.refereePoints,
      referralImage: postData.referralImage,
      referralStatus: postData.referralStatus?.value,
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"referralsettings"} />
          <div className="layout-page">
            <Topmenu />
            <ToastContainer />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{this.state.editID !== "" ? "Update" : "Add New"} Referral Settings</h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <Postform
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  outletList={this.state.outletList}
                  onChange={this.fieldChange}
                  sateValChange={this.sateValChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 160,
                          },
                          100
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { referralTitle, referralOutlet, referrerPoints, refereePoints,  referralImage, referralStatus } = props.fields;

  return {
    fields: ["referralTitle", "referralOutlet", "referrerPoints", "refereePoints", "referralImage", "referralStatus"],

    validations: {
      referralOutlet: [[isMultiSelect, referralOutlet]],
      referralTitle: [[isEmpty, referralTitle]],
      referrerPoints: [[isEmpty, referrerPoints]],
      refereePoints: [[isEmpty, refereePoints]],
      referralImage: [[isEmpty, referralImage]],
      referralStatus: [[isSingleSelect, referralStatus]],
    },
  };
}

class Postform extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modleType: "",
    };
    this.setContent = this.setContent.bind(this);
  }

  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  setContent(value) {
    this.props.onChange("referralInformation", value);
  }
  async uplaodreferralImage(imageType) {

    this.props.sateValChange("btndisabled", true);
    showLoader("ImageDetails");
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#" + imageType);
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "referral", "client", "epicpay");
    if (fileDetail.status === "ok") {
      this.props.onChange(imageType, fileDetail.url);
    }
    hideLoader("ImageContainer");
    hideLoader("ImageDetails");
    $("#" + imageType).val("");
    this.props.sateValChange("btndisabled", false);
  }

  async removeImage(fileNamme, imageType, e) {
    e.preventDefault();
    showLoader("ImageDetails", "class");
    var fileDetail = await removeFile(fileNamme, "client", "epicpay");
    if (fileDetail.status === "ok") {
      hideLoader("ImageDetails", "class");
      this.props.onChange(imageType, "");
    }
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgreferralTitle, errMsgOutlet, errMsgreferrerPoints, errMsgrefereePoints,
      errMsgreferralImage,
      errMsgreferralStatus = "";
    if ($validation.referralTitle.error.reason !== undefined) {
      errMsgreferralTitle = $validation.referralTitle.show && <span className="error">{$validation.referralTitle.error.reason}</span>;
    }
    if ($validation.referralOutlet.error.reason !== undefined) {
      errMsgOutlet = $validation.referralOutlet.show && (
        <span className="error">{$validation.referralOutlet.error.reason}</span>
      );
    }
    if ($validation.referrerPoints.error.reason !== undefined) {
      errMsgreferrerPoints = $validation.referrerPoints.show && <span className="error">{$validation.referrerPoints.error.reason}</span>;
    }
    if ($validation.refereePoints.error.reason !== undefined) {
      errMsgrefereePoints = $validation.refereePoints.show && <span className="error">{$validation.refereePoints.error.reason}</span>;
    }    
    if ($validation.referralImage.error.reason !== undefined) {
      errMsgreferralImage = $validation.referralImage.show && <span className="error">{$validation.referralImage.error.reason}</span>;
    }
    if ($validation.referralStatus.error.reason !== undefined) {
      errMsgreferralStatus = $validation.referralStatus.show && <span className="error">{$validation.referralStatus.error.reason}</span>;
    }

    const companyPlans = cookie.load("companyPlans") ?? "";

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3 pt-5">
          <div className={`col-md-12`}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className={errMsgreferralTitle !== "" && errMsgreferralTitle !== false && errMsgreferralTitle !== undefined ? "form-control is-invalid" : "form-control"}
                    name="referralTitle"
                    value={fields.referralTitle}
                    {...$field("referralTitle", (e) => onChange("referralTitle", e.target.value))}
                  />
                  <label htmlFor="referralTitle">
                    Title <span className="error">*</span>
                  </label>
                  {errMsgreferralTitle}
                </div>
              </div>
              <div
                                    className={
                                      errMsgOutlet !== "" &&
                                      errMsgOutlet !== false &&
                                      errMsgOutlet !== undefined
                                        ? "col-md-6 error-select error"
                                        : "col-md-6"
                                    }
                                  >
                                    <div className="form-floating form-floating-outline custm-select-box mb-4">
                                      <Select
                                        value={fields.referralOutlet}
                                        onChange={this.handleSelectChange.bind(
                                          this,
                                          "referralOutlet"
                                        )}
                                        placeholder={"Select Outlet"}
                                        options={this.props.outletList}
                                        isMulti
                                        isClearable={true}
                                      />
                                      <label className="select-box-label">
                                        Outlet<span className="error">*</span>
                                      </label>
                                      {errMsgOutlet}
                                    </div>
                                  </div>
          
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="text"
                      className={errMsgreferrerPoints !== "" && errMsgreferrerPoints !== false && errMsgreferrerPoints !== undefined ? "form-control is-invalid" : "form-control"}
                      name="referrerPoints"
                      id="referrerPoints"
                      value={fields.referrerPoints}
                      {...$field("referrerPoints", (e) => onChange("referrerPoints", e.target.value))}
                    />
                    <label htmlFor="referrerPoints">Referrer Points</label>
                    {errMsgreferrerPoints}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-floating form-floating-outline mb-4">
                    <input
                      type="text"
                      className={errMsgrefereePoints !== "" && errMsgrefereePoints !== false && errMsgrefereePoints !== undefined ? "form-control is-invalid" : "form-control"}
                      name="refereePoints"
                      id="refereePoints"
                      value={fields.refereePoints}
                      {...$field("refereePoints", (e) => onChange("refereePoints", e.target.value))}
                    />
                    <label htmlFor="refereePoints">Referee Points</label>
                    {errMsgrefereePoints}
                  </div>
                </div>
             
              <div className={errMsgreferralStatus !== "" && errMsgreferralStatus !== false && errMsgreferralStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                <div className="form-floating form-floating-outline custm-select-box">
                  <Select
                    value={fields.referralStatus}
                    onChange={this.handleSelectChange.bind(this, "referralStatus")}
                    placeholder="Select Status"
                    options={[
                     { value: "A", label: "Active" },
                          { value: "I", label: "Inactive" },
                    ]}
                  />
                  <label className="select-box-label">
                    Status<span className="error">*</span>
                  </label>
                  {errMsgreferralStatus}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <label>Referral Information</label>
            <Editor data={fields.referralInformation} IDName={"editorContent"} />
          </div>
          <div className="col-md-12">
              <label>Terms and Conditions</label>
              <Editor
                IDName={"editorContent2"}
                data={fields.referralTermsandConditions}
              />
            </div>

          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <div className="mb-3" id="ImageContainer">
                <label htmlFor="formFile" className="form-label">
                  Referral Image
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="referralImage"
                  onChange={(event) => {
                    this.uplaodreferralImage("referralImage", event);
                    return false;
                  }}
                />
              </div>
            </div>
            {fields.referralImage !== "" && (
              <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                <div className="dz-details" id="ImageDetails">
                  <div className="dz-thumbnail">
                    <img alt="" src={fields.referralImage} />
                  </div>
                </div>
                <a className="dz-remove" href={"/"} onClick={this.removeImage.bind(this, fields.referralImage, "referralImage")}>
                  Remove file
                </a>
              </div>
            )}
          </div>

          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
Postform = validated(validationConfig)(Postform);
